import { StepCategory, type AppData } from '../../../types/app_data';
import type { Step } from '../../types/step';

export const GarageOnlyCarValueMonthlyUpdate: Step = {
  id: 'garageonlycarvaluemonthlyupdate',
  pathname: '/garageonlycarvaluemonthlyupdate',
  canShow: (appData: AppData) => {
    // return appData.garageOnlyFlowPageTempData?.carValueAccepted === true;
    return true; // https://app.asana.com/0/1207252993552442/1209300190756268, https://miro.com/app/board/uXjVKpT4CFQ=/?moveToWidget=3458764608635246552&cot=14
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    return true;
  },
  category: () => StepCategory.GarageOnlyServices,
};
